module.exports = __webpack_public_path__ + "img/eco-test.333d07af.png";